/* eslint-disable */
import moment from 'moment';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../../Actions';
import analyticsAction from '../../../../Actions/analytics.actions';
// import { DefectImageResult } from '../../../../Components/Analytics/Defect';
import ImagesFinder from '../../../../Components/ImagesFinder/ImagesFinder';
import { ImagesResult } from '../../../../Components/ImagesResult';
import { DefectImageModal } from '../../../../Components/Modals';
import { modalTypes, urls } from '../../../../Constants';
import temperatureAnalyticsServices from '../../../../Services/Analytics Services/temperature-analytics.services';
import { liveQCServices } from '../../../../Services/LiveQC';
import styles from './TemperatureImagesPage.module.scss';
import { Button, Chip } from '@mui/material';
import { Filter } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import { filtersInfoChip } from '@/Helpers';
import { SelectPicker } from 'rsuite';
import { useAuth } from '@/Components/Auth/Login/auth';

// const source =
// 'https://www.thespruceeats.com/thmb/vJUFf6L4p8y9Cn_1pE9Z7Ua9uok=/3000x2001/filters:fill(auto,1)/indian-style-burger-1957599-hero-01-266103a4bb4e4ee7b5feb4da2d2e99da.jpg';

const TemperatureImagesPage = (props) => {
	const [filters, setFilters] = useState({
		store: null,
		processTypes: null,
		brand: null,
		featureType: 'QUALITY',
		defects: [],
		products: [],
		vendors: [],
		imagesType: undefined,
		productCategories: [],
		identification: 'Both',
		submissions: 0,
		timeType: {
			value: '',
			label: '',
		},
		dateRange: {
			active: false,
			from: new Date(),
			to: new Date(),
		},
	});

	const [pageLimit, setPageLimit] = useState(6);
	const { userConfig = {} } = useAuth();
	const { level } = userConfig?.userDetails || {};
	const {
		allTemperatureResults,
		fetchTemperatureImages,
		updateTemperatureImagesList,
		resetTemperatureImages,
		toggleModal,
		userPermissions,
		toggleFiltersDrawer
	} = props;

	useEffect(() => {
		resetTemperatureImages();
	}, []);

	const submitFindRequest = ({
		store = null,
		processTypes = null,
		brand,
		featureType,
		defects = [],
		products = [],
		productCategories = [],
		identification,
		imagesType = undefined,
		timeType,
		vendors = [],
		dateRange = {},
	}) => {
		resetTemperatureImages();
		setFilters({
			store,
			brand,
			processTypes,
			featureType,
			defects,
			products,
			vendors,
			imagesType,
			productCategories,
			identification,
			submissions: filters.submissions + 1,
			timeType : timeType,
			dateRange,
		});
		fetchTemperatureImages({
			entity: 'TEMPERATURE_ANALYSIS',
			method: 'FIND_TEMPERATURE_IMAGES',
			req: {
				params: {
					limit: pageLimit,
				},
				data: {
					storeId: store?.id,
					brandId: brand?.id,
					processTypes : processTypes?.id,
					labels: defects,
					products: products?.id,
					vendors: vendors?.id,
					imagesType,
					productCategories: productCategories?.id,
					identification,
					type: featureType,
					dateRangeFilter: dateRange?.active
						? {
							timeType : timeType?.value,
							from: moment(dateRange?.from).format(
								'YYYY-MM-DD'
							),
							to: moment(dateRange?.to).format('YYYY-MM-DD'),
						}
						: {},
				},
			},
		});
	};

	const fetchQCData = async (qcId) => {
		try {
			const req = {
				params: {
					qcId,
				},
			};

			const { data = null } = await liveQCServices.getPastData(req);

			return data;
		} catch {
			return null;
		}
	};

	const fetchTemperatureImagesById = async ({ page, id }, index) => {
		const response = await temperatureAnalyticsServices.fetchImagesById({
			params: {
				page,
				limit: pageLimit,
			},
			data: {
				assetId: id,
				storeId: filters.store?.id,
				products: filters.products?.id,
				processTypes: filters.processTypes?.id,
				brandId: filters.brand?.id,
				vendors: filters.vendors?.id,
				imagesType: id ? 'ASSET' : 'TRANSIT',
				productCategories: filters.productCategories?.id,
				identification: filters?.identification,
				type: filters?.featureType,
				dateRangeFilter: filters?.dateRange?.active
					? {
						timeType: filters?.timeType?.value,
						from: moment(filters?.dateRange.from).format(
							'YYYY-MM-DD'
						),
						to: moment(filters?.dateRange.to).format(
							'YYYY-MM-DD'
						),
					}
					: {},
			},
		});

		const { data = [] } = response;
		updateTemperatureImagesList(index, data);
		return data;
	};

	const onItemClick = async ({ annotation, item: product }) => {
		const qcData = await fetchQCData(annotation.qcId);
		const item = {
			source: annotation.image,
			name: qcData?.ProductName,
			product,
			date: qcData?.QCTime,
			link:
				qcData != null
					? `${urls.EXTENSION}${urls.PAST_QC}/${qcData?.itemId}?id=${qcData?.id}`
					: null,
		};
		toggleModal(true, {
			item,
		});
	};

	const filtersInfo = {
		header: {
			store: false,
			statusAndTypes:false,
			date:false,
			process:false,
		},
		filteredStore: {
			show: true,
			text: 'Images from',
		},
		processType: {
			show: true,
			text: 'Process Type',
		},
		imagesType: {
			show: true,
			text: 'Images Type',
		},
		dateRange: {
			show: true,
			text: 'Date Range',
		},
		timeType: {
			show: true,
			text: 'Date TimeType',
		},	
	}

	const exportInfo = {
		hideExportAccordian : true,
	};

	return (
		<div className={styles.root}>
			<DefectImageModal />
			<ImagesFinder  
				onSubmit={submitFindRequest} 
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>Temperature Images</span>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true);
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span>Filter</span>
					<Filter className='size-4' />
				</Button>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className='flex items-center gap-2'>
				<span>
					Page Limit : 
				</span>
				<SelectPicker
					data={[6, 25, 50, 100].map((item) => ({
						label: item,
						value: item,
					}))}
					value={pageLimit}
					onChange={(value) => setPageLimit(value)}
					searchable={false}
					className='w-[200px]'
				/>
			</div>
			<div className={styles['image-results']}>
				{allTemperatureResults.map((defect, index) => {
					return (
						<ImagesResult
							key={`${defect.id}${filters.submissions}`}
							identification={filters?.identification}
							// fetchQCData={fetchQCData}
							type='TEMPERATURE_IMAGES'
							fetchMoreImages={(req) => {
								return fetchTemperatureImagesById(req, index);
							}}
							currentItem={defect}
							onItemClick={onItemClick}
							isInternal={level !== 1}
						/>
					);
				})}
				{allTemperatureResults.length === 0 && (
					<p className={styles.fallback}>No items to display</p>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { FIND_TEMPERATURE_IMAGES: allTemperatureResults } =
		state.analytics.TEMPERATURE_ANALYSIS;
	const { userPermissions } = state.navigation;
	const { DATE_RANGE_FILTER: dateRangeFilter } = state.analytics;
	return {
		allTemperatureResults,
		dateRangeFilter,
		userPermissions,
	};
};

const mapDispatchToProps = (dispatch) => {
	
	return {
		toggleFiltersDrawer: (show, data = {}) => {
			dispatch(drawerActions.toggleFiltersDrawer(show, data));
		},
		fetchTemperatureImages: (...args) => {
			dispatch(analyticsAction.gateway(...args));
		},
		updateTemperatureImagesList: (...args) => {
			dispatch(analyticsAction.updateTemperatureImagesList(...args));
		},
		resetTemperatureImages: () => {
			dispatch(analyticsAction.resetTemperatureImages());
		},
		toggleModal: (show, data = {}) => {
			dispatch(
				modalActions.toggleModal(modalTypes.DEFECT_IMAGE, show, data)
			);
		},
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(TemperatureImagesPage);
